import ApiService from './ApiService.js';
const querystring = require('querystring')
var CompanyService = {

    findAll: function($data)
     {
        return new Promise(function(resolve,reject) {
            var $options= {};
             $options.url ="company"
             $options.method="get"
        
            if($data) {
                $options.url="company?filter="+JSON.stringify($data)
               
                //$options.url="http://localhost:3020/company?filter="+querystring.stringify($data)
                console.log($options.url)
            }
            ApiService.request($options) 
            
                .then(response => {
                   console.log('test');
                    resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });

    },

    
    findOne: function($data)
     {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="company/"+$data.id
            console.log($options.url)
            $options.method="get"
            if(!$data) {
                $options.data = $data
            }
            ApiService.request($options)
                .then(response => {
                   // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });

    },
    save: function ($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data={};
            console.log($data)
            //$options.data.id =  uuidv1();
            //$options.data.id =$data.id
            $options.data.company_code =$data.company_code
            $options.data.name= $data.name;
            $options.data.address1 = $data.address1
            $options.data.address2 = $data.address2
            $options.data.city = $data.city
            $options.data.country_id = $data.country_id
            $options.data.state_id = $data.state_id
            $options.data.zip = $data.zip
            $options.data.auth_type = $data.auth_type
            $options.data.active = $data.active
            $options.data.erp_profile =$data.erp_profile
            $options.data.db_info = $data.db_info
            $options.data.description = $data.description
            $options.data.db_connection_string = $data.db_connection_string
            $options.data.logo_profile_id =$data.logo_profile_id
            // $options.data.api_key =$data.api_key
            // $options.data.shared_secrect =$data.shared_secrect
            // $options.data.url =$data.url
            $options.url = "company/"+$data.id;
            $options.method="post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });
    },
    
    create: function ($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data={};
            console.log($data)
            //$options.data.id =  uuidv1();
            $options.data.company_code =$data.company_code
            $options.data.name= $data.name;
            $options.data.address1 = $data.address1
            $options.data.address2 = $data.address2
            $options.data.city = $data.city
            $options.data.country_id = $data.country_id
            $options.data.logo_profile_id =$data.logo_profile_id
            // $options.data.api_key =$data.api_key
            // $options.data.shared_secrect =$data.shared_secrect
            // $options.data.url =$data.url
            $options.data.erp_profile =$data.erp_profile
            $options.data.state_id = $data.state_id
            $options.data.zip = $data.zip
            $options.data.auth_type = $data.auth_type
            $options.data.active = $data.active
            $options.data.image_path = $data.image_path
            $options.data.db_info = $data.db_info
            $options.data.description = $data.description
            $options.data.db_connection_string = $data.db_connection_string
            $options.url = "company";
            $options.method="post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });
    },

    companySignup: function ($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data={};
            console.log($data)
            //$options.data.id =  uuidv1();
            $options.data.company_code =$data.company_code
            $options.data.name= $data.name;
            $options.data.team= $data.team;
            $options.data.address1 = $data.address1
            $options.data.address2 = $data.address2
            $options.data.city = $data.city
            $options.data.country_id = $data.country_id
            $options.data.state_id = $data.state_id
            $options.data.zip = $data.zip
            $options.data.auth_type = $data.auth_type
            $options.data.active = $data.active
            $options.data.db_info = $data.db_info
            $options.data.description = $data.description
            $options.url = "companySignup";
            $options.method="post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });
    },

    
    //{"team":this.form.team}
    validateTeam: function($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data={};
            console.log($data)
            //$options.url ='company/validateTeam'
            $options.url="validateTeam/"+$data
            $options.data = $data;
            ApiService.request($options) 
                .then(response => {
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error )

                });
            });

    },
    validate: function($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data={};
            console.log($data)
            $options.url ='company/validate'
            $options.data = $data;
            ApiService.request($options) 
                .then(response => {

                }).catch(error => {

                });
            });

    },
    formatData: function($data) 
    {
        var $i =0;
        var $companies = $data.data.data;
        var $companyList = []; 
        var $length = $companies.length; 
        console.log($companies)
        for($i=0;$i<$length;$i++) {
            var $options = {};
            $options.id = $companies[$i].companies.id;
            $options.name = $companies[$i].companies.companyName;
            $options.city = $companies[$i].companies.city;
            $options.countryName = 'United States' //$companies[$i].countryName;
            $options.stateName = $companies[$i].stateName;
            $options.active = $companies[$i].active=1 ? 'Active' : 'InActive'
            $options.modified =$companies[$i].modified
            $options.expiry = $companies[$i].expires_on
            $options.authTypeDesc =$companies[$i].companies.auth_type;
            $options.db_connection_string = $companies[$i].companies.db_connection_string
          
            $options.twoFactorAuth  = $companies[$i].companies.two_factor_auth==1 ? 'Enabled' : 'Disabled';
            $companyList.push($options)
            //$company.push($options)
            console.log('record finsihed');

        }
        console.log('returned data')
        return $companyList;
    }
};
export default CompanyService;